<!-- <app-common-header
  [isAdminOrTutor]="role === '1' || role === '2'"
></app-common-header> -->
<div class="body">
  <div class="mainContent">
    <div class="online-test">
      <span class="online-test__heading">Online Test</span>
      <div
        class="online-test__header online-test__header__hideTimer"
        id="online-test__timer"
      >
        <span class="online-test__header__timer">{{ getTime(timeLeft) }}</span>
      </div>
      <div class="online-test__header">
        <div class="online-test__header__block">
          <span class="online-test__header__block__label">Test Type:</span>
          <span class="online-test__header__block__text">{{ testType }}</span>
        </div>
        <div class="online-test__header__block">
          <span class="online-test__header__block__label">Test Code:</span>
          <span class="online-test__header__block__text">{{ testCode }}</span>
        </div>
        <div class="online-test__header__block">
          <span class="online-test__header__block__label">Test Date:</span>
          <span class="online-test__header__block__text">{{ testDate }}</span>
        </div>
        <button
          class="online-test__header__changeTest"
          [routerLink]="['/list-of-tests']"
        >
          Change Test
        </button>
      </div>
      <div class="online-test__header online-test__header__mobileSelectSection">
        <mat-select [(value)]="mobileSelectedIndex" [disabled]="timer">
          <mat-option
            *ngFor="let section of sections; index as i"
            [value]="i"
            >{{ section["testSection"] }}</mat-option
          >
        </mat-select>
      </div>
      <div class="online-test__testBody">
        <ng-container *ngFor="let section of sections; index as sectionIndex">
          <div
            class="online-test__testBody__section"
            [ngClass]="
              mobileSelectedIndex === sectionIndex
                ? 'online-test__testBody__section__mobileDisplay'
                : ''
            "
          >
            <span class="online-test__testBody__section__sectionName"
              >Section {{ sectionIndex + 1 }} -
              {{ section["testSection"] }}</span
            >
            <span class="online-test__testBody__section__time"
              >Time: {{ getTime(section["sectionTime"]) }}</span
            >
            <div class="online-test__testBody__section__answers">
              <div
                class="online-test__testBody__section__answers__buttonStack"
                [ngClass]="
                  isPauseAllowed && timerBlockIndex === sectionIndex
                    ? 'online-test__testBody__section__answers__buttonStack--twoColumns'
                    : ''
                "
              >
                <button
                  class="button"
                  [id]="
                    'online-test__testBody__section__answers__buttonStack__' +
                    sectionIndex
                  "
                  [ngClass]="
                    submittedSections.indexOf(sectionIndex) > -1
                      ? 'online-test__testBody__section__answers__buttonStack--hide'
                      : ''
                  "
                  (click)="
                    timerBlockIndex === sectionIndex
                      ? false
                      : startTimerBlock(sectionIndex)
                  "
                  [disabled]="
                    submittedSections.indexOf(sectionIndex) > -1
                      ? true
                      : startTimerClicked
                      ? true
                      : timerBlockIndex === null
                      ? false
                      : timerBlockIndex !== sectionIndex
                  "
                >
                  {{
                    timerBlockIndex === sectionIndex
                      ? getTime(timeLeft)
                      : pausedQuestions.indexOf(sectionIndex) > -1
                      ? "Continue"
                      : section["studentAnswers"]["length"] > 0
                      ? "Continue"
                      : "Start"
                  }}
                </button>
                <button
                  *ngIf="isPauseAllowed && timerBlockIndex === sectionIndex"
                  (click)="pauseTest()"
                  [disabled]="pauseClicked"
                  class="button"
                >
                  Pause
                </button>
              </div>
              <div *ngIf="testType === 'SAT' || testType === 'PSAT'">
                <ng-container
                  *ngFor="
                    let question of section['sectionQuestionIds'];
                    index as i
                  "
                >
                  <div
                    class="online-test__testBody__section__answers__block"
                    *ngIf="question['isChar'] !== 0"
                  >
                    <span
                      class="online-test__testBody__section__answers__block__questionNumber"
                      >{{ i + 1 }}.</span
                    >
                    <span
                      class="online-test__testBody__section__answers__block__option"
                      [class.online-test__testBody__section__answers__block__option--selected]="
                        questions['controls'][sectionIndex]['controls'][i][
                          'value'
                        ] === 'A'
                      "
                      [class.online-test__testBody__section__answers__block__option--disabled]="
                        timerBlockIndex !== sectionIndex ||
                        timeLeft === 0 ||
                        timer === null ||
                        pauseClicked ||
                        submittedQuestions.indexOf(i) > -1
                      "
                      (click)="
                        timerBlockIndex !== sectionIndex ||
                        timeLeft === 0 ||
                        timer === null ||
                        pauseClicked ||
                        submittedQuestions.indexOf(i) > -1
                          ? false
                          : selectOption('A', i)
                      "
                      >A</span
                    >
                    <span
                      class="online-test__testBody__section__answers__block__option"
                      [ngClass]="
                        questions['controls'][sectionIndex]['controls'][i][
                          'value'
                        ] === 'B'
                          ? 'online-test__testBody__section__answers__block__option--selected'
                          : ''
                      "
                      [class.online-test__testBody__section__answers__block__option--disabled]="
                        timerBlockIndex !== sectionIndex ||
                        timeLeft === 0 ||
                        timer === null ||
                        pauseClicked ||
                        submittedQuestions.indexOf(i) > -1
                      "
                      (click)="
                        timerBlockIndex !== sectionIndex ||
                        timeLeft === 0 ||
                        timer === null ||
                        pauseClicked ||
                        submittedQuestions.indexOf(i) > -1
                          ? false
                          : selectOption('B', i)
                      "
                      >B</span
                    >
                    <span
                      class="online-test__testBody__section__answers__block__option"
                      [ngClass]="
                        questions['controls'][sectionIndex]['controls'][i][
                          'value'
                        ] === 'C'
                          ? 'online-test__testBody__section__answers__block__option--selected'
                          : ''
                      "
                      [class.online-test__testBody__section__answers__block__option--disabled]="
                        timerBlockIndex !== sectionIndex ||
                        timeLeft === 0 ||
                        timer === null ||
                        pauseClicked ||
                        submittedQuestions.indexOf(i) > -1
                      "
                      (click)="
                        timerBlockIndex !== sectionIndex ||
                        timeLeft === 0 ||
                        timer === null ||
                        pauseClicked ||
                        submittedQuestions.indexOf(i) > -1
                          ? false
                          : selectOption('C', i)
                      "
                      >C</span
                    >
                    <span
                      class="online-test__testBody__section__answers__block__option"
                      [ngClass]="
                        questions['controls'][sectionIndex]['controls'][i][
                          'value'
                        ] === 'D'
                          ? 'online-test__testBody__section__answers__block__option--selected'
                          : ''
                      "
                      [class.online-test__testBody__section__answers__block__option--disabled]="
                        timerBlockIndex !== sectionIndex ||
                        timeLeft === 0 ||
                        timer === null ||
                        pauseClicked ||
                        submittedQuestions.indexOf(i) > -1
                      "
                      (click)="
                        timerBlockIndex !== sectionIndex ||
                        timeLeft === 0 ||
                        timer === null ||
                        pauseClicked ||
                        submittedQuestions.indexOf(i) > -1
                          ? false
                          : selectOption('D', i)
                      "
                      >D</span
                    >
                  </div>
                  <div
                    class="online-test__testBody__section__answers__block"
                    *ngIf="question['isChar'] === 0"
                  >
                    <span
                      class="online-test__testBody__section__answers__block__questionNumber"
                      >{{ i + 1 }}.</span
                    >

                    <input
                      class="online-test__testBody__section__answers__block__input"
                      [value]="
                        questions['controls'][sectionIndex]['controls'][i][
                          'value'
                        ]
                      "
                      *ngIf="
                        timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1;
                        else enabledInput
                      "
                      type="text"
                      disabled
                    />
                    <ng-template #enabledInput>
                      <input
                        [formControl]="
                          questions['controls'][sectionIndex]['controls'][i]
                        "
                        class="online-test__testBody__section__answers__block__input"
                        [ngClass]="
                          (submitError ||
                            questions['controls'][sectionIndex]['controls'][i][
                              'touched'
                            ]) &&
                          questions['controls'][sectionIndex]['controls'][i][
                            'invalid'
                          ]
                            ? 'online-test__testBody__section__answers__block__input__error'
                            : ''
                        "
                        (input)="numberValidator($event)"
                        (focusout)="submitNumber(i)"
                        maxlength="4"
                        type="text"
                      />
                    </ng-template>
                  </div>
                </ng-container>
              </div>
              <div *ngIf="testType === 'ACT' || testType === 'PACT'">
                <ng-container
                  *ngFor="
                    let question of section['sectionQuestionIds'];
                    index as i
                  "
                >
                  <div *ngIf="i % 2 === 0">
                    <div
                      class="online-test__testBody__section__answers__block"
                      *ngIf="question['isChar'] !== 0"
                    >
                      <span
                        class="online-test__testBody__section__answers__block__questionNumber"
                        >{{ i + 1 }}.</span
                      >
                      <span
                        class="online-test__testBody__section__answers__block__option"
                        [class.online-test__testBody__section__answers__block__option--selected]="
                          questions['controls'][sectionIndex]['controls'][i][
                            'value'
                          ] === 'A'
                        "
                        [class.online-test__testBody__section__answers__block__option--disabled]="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                        "
                        (click)="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                            ? false
                            : selectOption('A', i)
                        "
                        >A</span
                      >
                      <span
                        class="online-test__testBody__section__answers__block__option"
                        [ngClass]="
                          questions['controls'][sectionIndex]['controls'][i][
                            'value'
                          ] === 'B'
                            ? 'online-test__testBody__section__answers__block__option--selected'
                            : ''
                        "
                        [class.online-test__testBody__section__answers__block__option--disabled]="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                        "
                        (click)="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                            ? false
                            : selectOption('B', i)
                        "
                        >B</span
                      >
                      <span
                        class="online-test__testBody__section__answers__block__option"
                        [ngClass]="
                          questions['controls'][sectionIndex]['controls'][i][
                            'value'
                          ] === 'C'
                            ? 'online-test__testBody__section__answers__block__option--selected'
                            : ''
                        "
                        [class.online-test__testBody__section__answers__block__option--disabled]="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                        "
                        (click)="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                            ? false
                            : selectOption('C', i)
                        "
                        >C</span
                      >
                      <span
                        class="online-test__testBody__section__answers__block__option"
                        [ngClass]="
                          questions['controls'][sectionIndex]['controls'][i][
                            'value'
                          ] === 'D'
                            ? 'online-test__testBody__section__answers__block__option--selected'
                            : ''
                        "
                        [class.online-test__testBody__section__answers__block__option--disabled]="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                        "
                        (click)="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                            ? false
                            : selectOption('D', i)
                        "
                        >D</span
                      >
                      <ng-container *ngIf="section['testSection'] === 'Math'">
                        <span
                          class="online-test__testBody__section__answers__block__option"
                          [ngClass]="
                            questions['controls'][sectionIndex]['controls'][i][
                              'value'
                            ] === 'E'
                              ? 'online-test__testBody__section__answers__block__option--selected'
                              : ''
                          "
                          [class.online-test__testBody__section__answers__block__option--disabled]="
                            timerBlockIndex !== sectionIndex ||
                            timeLeft === 0 ||
                            timer === null ||
                            pauseClicked ||
                            submittedQuestions.indexOf(i) > -1
                          "
                          (click)="
                            timerBlockIndex !== sectionIndex ||
                            timeLeft === 0 ||
                            timer === null ||
                            pauseClicked ||
                            submittedQuestions.indexOf(i) > -1
                              ? false
                              : selectOption('E', i)
                          "
                          >E</span
                        >
                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="i % 2 !== 0">
                    <div
                      class="online-test__testBody__section__answers__block"
                      *ngIf="question['isChar'] !== 0"
                    >
                      <span
                        class="online-test__testBody__section__answers__block__questionNumber"
                        >{{ i + 1 }}.</span
                      >
                      <span
                        class="online-test__testBody__section__answers__block__option"
                        [class.online-test__testBody__section__answers__block__option--selected]="
                          questions['controls'][sectionIndex]['controls'][i][
                            'value'
                          ] === 'F'
                        "
                        [class.online-test__testBody__section__answers__block__option--disabled]="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                        "
                        (click)="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                            ? false
                            : selectOption('F', i)
                        "
                        >F</span
                      >
                      <span
                        class="online-test__testBody__section__answers__block__option"
                        [ngClass]="
                          questions['controls'][sectionIndex]['controls'][i][
                            'value'
                          ] === 'G'
                            ? 'online-test__testBody__section__answers__block__option--selected'
                            : ''
                        "
                        [class.online-test__testBody__section__answers__block__option--disabled]="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                        "
                        (click)="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                            ? false
                            : selectOption('G', i)
                        "
                        >G</span
                      >
                      <span
                        class="online-test__testBody__section__answers__block__option"
                        [ngClass]="
                          questions['controls'][sectionIndex]['controls'][i][
                            'value'
                          ] === 'H'
                            ? 'online-test__testBody__section__answers__block__option--selected'
                            : ''
                        "
                        [class.online-test__testBody__section__answers__block__option--disabled]="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                        "
                        (click)="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                            ? false
                            : selectOption('H', i)
                        "
                        >H</span
                      >
                      <span
                        class="online-test__testBody__section__answers__block__option"
                        [ngClass]="
                          questions['controls'][sectionIndex]['controls'][i][
                            'value'
                          ] === 'J'
                            ? 'online-test__testBody__section__answers__block__option--selected'
                            : ''
                        "
                        [class.online-test__testBody__section__answers__block__option--disabled]="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                        "
                        (click)="
                          timerBlockIndex !== sectionIndex ||
                          timeLeft === 0 ||
                          timer === null ||
                          pauseClicked ||
                          submittedQuestions.indexOf(i) > -1
                            ? false
                            : selectOption('J', i)
                        "
                        >J</span
                      >
                      <ng-container *ngIf="section['testSection'] === 'Math'">
                        <span
                          class="online-test__testBody__section__answers__block__option"
                          [ngClass]="
                            questions['controls'][sectionIndex]['controls'][i][
                              'value'
                            ] === 'K'
                              ? 'online-test__testBody__section__answers__block__option--selected'
                              : ''
                          "
                          [class.online-test__testBody__section__answers__block__option--disabled]="
                            timerBlockIndex !== sectionIndex ||
                            timeLeft === 0 ||
                            timer === null ||
                            pauseClicked ||
                            submittedQuestions.indexOf(i) > -1
                          "
                          (click)="
                            timerBlockIndex !== sectionIndex ||
                            timeLeft === 0 ||
                            timer === null ||
                            pauseClicked ||
                            submittedQuestions.indexOf(i) > -1
                              ? false
                              : selectOption('K', i)
                          "
                          >K</span
                        >
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <button
              class="button online-test__testBody__section__submit"
              (click)="submitTest('userSubmit', sectionIndex)"
              [disabled]="
                submitClicked ||
                (!submitClicked &&
                  (timerBlockIndex !== sectionIndex ||
                    timerBlockIndex === null))
              "
            >
              Submit
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
